import { Injectable } from '@angular/core';
import { HPMNCountry } from '../model/HPMNCountry';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  getHPMNCountry() {
    return [
      new HPMNCountry('MTN_Ghana', 'MTN_Ghana')
    ];
  }
}
